module.exports = __webpack_public_path__ + "static/media/twomini.c1cb7a24.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/icons/classes/twomini.png
// module id = 655
// module chunks = 0